const WebVideoCtrl = window.WebVideoCtrl;
const $ = window.jQuery;
export default {
  data() {
    return {
      iStreamType: '1', // 码流类型 1.主码流 2.子码流 3.第三码流 4.转码码流
      channelListMap: {}
    };
  },
  methods: {
    videoLogin(loginInfo, fn) {
      const that = this;
      const iRet = WebVideoCtrl.I_Login(
        loginInfo.loginIp,
        1,
        loginInfo.loginPort,
        loginInfo.userName,
        loginInfo.password,
        {
          success: function(xmlDoc) {
            setTimeout(function() {
              that.getChannelInfo(loginInfo, fn);
            }, 10);
          },
          error: function() {
            console.error('登录失败！');
          }
        }
      );

      if (iRet === -1) {
        setTimeout(function() {
          that.getChannelInfo(loginInfo, fn);
        }, 10);
      }
    },
    getChannelInfo(loginInfo, fn) {
      const that = this;
      // 模拟通道
      WebVideoCtrl.I_GetAnalogChannelInfo(that.loginIp, {
        async: false,
        success: function(xmlDoc) {
          const oChannels = $(xmlDoc).find('InputProxyChannelStatus');
          $.each(oChannels, function(i) {
            that.channelList.push({
              id: $(this)
                .find('id')
                .eq(0)
                .text(),
              name: $(this)
                .find('name')
                .eq(0)
                .text()
            });
          });
        },
        error: function() {
          console.error('获取模拟通道失败！');
        }
      });
      // 数字通道
      WebVideoCtrl.I_GetDigitalChannelInfo(loginInfo.loginIp, {
        async: false,
        success: function(xmlDoc) {
          const oChannels = $(xmlDoc).find('InputProxyChannelStatus');
          const channelList = [];
          $.each(oChannels, function(i) {
            channelList.push({
              id: $(this)
                .find('id')
                .eq(0)
                .text(),
              name: $(this)
                .find('name')
                .eq(0)
                .text()
            });
          });
          that.channelListMap[loginInfo.id] = channelList;
          fn();
        },
        error: function() {
          console.error('获取数字通道失败！');
        }
      });
      // 零通道
      WebVideoCtrl.I_GetZeroChannelInfo(that.loginIp, {
        async: false,
        success: function(xmlDoc) {
          const oChannels = $(xmlDoc).find('InputProxyChannelStatus');
          $.each(oChannels, function(i) {
            that.channelList.push({
              id: $(this)
                .find('id')
                .eq(0)
                .text(),
              name: $(this)
                .find('name')
                .eq(0)
                .text()
            });
          });
        },
        error: function() {
          console.error('获取零通道失败！');
        }
      });
    }
  }
};
